import { formatDate } from "@website-builder/utilities-index";

export default ({ header }, { storyList }) => {
	const contentType = "Program";
	return {
		header,
		programList: storyList?.[contentType] || [],
	};
};

export const dateTransform = (date) => {
	if (date) {
		return formatDate(date);
	} else {
		return "";
	}
};

export const filterStories = (stories) => {
	return stories.filter((story) => {
		const {
			content: { SEO },
		} = story;
		if (SEO && SEO.length) {
			const [{ disableIndex = false }] = SEO;
			return !disableIndex;
		} else return true;
	});
};
